import {
  CategoryOutlined,
  FavoriteBorder,
  Verified,
  Visibility,
} from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

const OwnerInfo = ({ ownerName, title, ownedBy, views, fav, number }) => {
  return (
    <Box ml={2}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography sx={{ color: "#2081E2", fontWeight: "bold" }} mr={1}>
          {ownerName}
        </Typography>
        <Verified sx={{ color: "#2081E2" }} fontSize='small' />
      </Box>
      <Typography
        variant='h5'
        sx={{ color: "#363A41" }}
        fontWeight={"bold"}
        my={3}
      >
        {title}
      </Typography>
      <Box sx={{ display: "flex" }}>
        <Typography>Owned by</Typography>
        <Typography sx={{ color: "#2081E2" }} ml={1}>
          {ownedBy}
        </Typography>
      </Box>
      <Box sx={{ display: "flex" }} my={3}>
        <Box
          sx={{
            border: "1px solid lightgray",
            borderRadius: "10px",
            py: "3px",
            px: "10px",
            fontWeight: "bold",
          }}
        >
          # {number}
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
          <Visibility sx={{ color: "#353840" }} />
          <Typography ml={1} color={"#353840"}>
            {views} views
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
          <FavoriteBorder sx={{ color: "#353840" }} />
          <Typography ml={1} color={"#353840"}>
            {fav} favorites
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
          <CategoryOutlined sx={{ color: "#353840" }} />
          <Typography ml={1} color={"#353840"}>
            PFPs
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default OwnerInfo;
